import { MenuConfigModel } from "api/repositories/sidebarMenu/model/SidebarMenuConfigModel";
import PrivateRoute from "components/layoutComponent/PrivateRoute";
import { AuthenticationContext } from "context/AuthenticationContext";
import { focusHandling } from "cruip-js-toolkit";
import AppPages from "navigations/AppPages";
import ChangePasswordFeature from "pages/changePassword/views/ChangePasswordFeature";
import GeneralFeature from "pages/generals/views/GeneralFeature";
import { ReactNode, Suspense, useEffect, useMemo } from "react";
import { Route, Routes, useLocation } from "react-router";
import Login from "./pages/login/Login";
import NotFound from "./pages/notFound/NotFound";

function App() {
  const location = useLocation();
  const { menuConfig } = AuthenticationContext();

  const loadingScreen = () => {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="loader">
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--text"></div>
        </div>
      </div>
    );
  };

  const mapMenuToRoutes = (menu: MenuConfigModel) => {
    const Components = AppPages?.getPage(menu?.componentName);
    return (
      <Route
        path={menu?.path}
        key={menu?.path}
        element={
          <PrivateRoute path={menu?.path} key={menu?.path}>
            <Suspense fallback={loadingScreen()}>
              <Components />
            </Suspense>
          </PrivateRoute>
        }
      />
    );
  };

  const routeRendering = useMemo(() => {
    let routes: Array<ReactNode> = [];
    menuConfig?.menu?.forEach((menu) => {
      routes.push(mapMenuToRoutes(menu));
      if (menu.subMenu?.length > 0) {
        menu.subMenu.forEach((subMenu) => {
          routes.push(mapMenuToRoutes(subMenu));
        });
      }
    });
    return routes;
  }, [menuConfig]);

  const pageRendering = () => {
    if (typeof window === undefined) {
      return <>{loadingScreen()}</>;
    } else {
      return (
        <>
          <Route
            path={"/"}
            key={"generals"}
            element={
              <PrivateRoute path={"/"} key={"generals"}>
                <Suspense fallback={loadingScreen()}>
                  <GeneralFeature />
                </Suspense>
              </PrivateRoute>
            }
          />
          <Route
            path={"/change-password"}
            key={"changePass"}
            element={
              <PrivateRoute path={"/change-password"} key={"changePass"}>
                <Suspense fallback={loadingScreen()}>
                  <ChangePasswordFeature />
                </Suspense>
              </PrivateRoute>
            }
          />
          {routeRendering}
        </>
      );
    }
  };

  useEffect(() => {
    document.querySelector("html").style.scrollBehavior = "auto";
    window.scroll({ top: 0 });
    document.querySelector("html").style.scrollBehavior = "";
    focusHandling(null);
  }, [location.pathname]);

  return (
    <Routes>
      <Route path="/login" element={<Login />}></Route>
      <>{pageRendering()}</>
      <Route path="/404" element={<NotFound />} />
    </Routes>
  );
}

export default App;
